import React from 'react';
import './title.css';

const Title = (props) => {
  return (
    <section className="page_title">
      <h1>{props.title}</h1>
      <div>{props.subtitle}</div>
    </section>
  );
};

export default Title;
